module.exports = __webpack_public_path__ + "img/canon.40c12af9.svg";